module.exports = __webpack_public_path__ + "img/19065121.9f1a3cdc.png";